import { NewsletterAudience } from '@hooks-api';

/**
 * Marketer-facing copy for each audience (ENG-1198). Both pools are members of
 * in-service companies; the toggle only decides whether marketing consent is
 * required, since “Product updates” is a service announcement rather than a
 * marketing campaign.
 */
export const AUDIENCE_COPY: Record<NewsletterAudience, { label: string; hint: string }> = {
  in_service: {
    label: 'In service',
    hint: 'Every member of a company that is in service, whether or not they opted in to marketing.',
  },
  opted_in: {
    label: 'Opted in',
    hint: 'Only in-service members who opted in to marketing emails.',
  },
};

export const audienceLabel = (audience: NewsletterAudience) => AUDIENCE_COPY[audience].label;
export const audienceHint = (audience: NewsletterAudience) => AUDIENCE_COPY[audience].hint;
